import FacebookShareButton from './facebook-share-button'
import PinterestShareButton from './pinterest-share-button'
import ShareButtons from './share-buttons'

export { FacebookShareButton, PinterestShareButton }
export default ShareButtons
